import { createStyleSheet } from '@shared-ui/theme'
import { rh, rw } from '@shared-ui/theme/scale'

export const useCreateStyles = createStyleSheet((theme) => ({
  button: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    gap: rw(8),
    paddingHorizontal: rw(20),
    borderRadius: rw(theme.SIZE_BUTTON_BORDER_RADIUS),
    height: rh(52),
    overflow: 'hidden',
  },
  text: {
    color: theme.COLOR_NEUTRAL_50,
    paddingHorizontal: rw(2),
    textAlign: 'center',
    zIndex: 1,
  },
  primaryButton: {
    backgroundColor: theme.COLOR_BG_INVERSE,
  },
  primaryButtonText: {
    color: theme.COLOR_TEXT_INVERSE_PRIMARY,
  },
  grayButton: {
    backgroundColor: theme.COLOR_BG_SURFACE,
  },
  grayButtonText: {
    color: theme.COLOR_TEXT_PRIMARY,
  },
  primaryLightButton: {
    backgroundColor: theme.COLOR_BG_BRAND_SECONDARY,
  },
  primaryLightButtonText: {
    color: theme.COLOR_TEXT_BRAND,
  },
  primaryLightButtonSecondary: {
    color: theme.COLOR_TEXT_PRIMARY,
  },
  whiteButton: {
    backgroundColor: theme.COLOR_NEUTRAL_50,
  },
  whiteButtonText: {
    color: theme.COLOR_NEUTRAL_950,
  },
  blackButton: {
    backgroundColor: theme.COLOR_BG_INVERSE, // color dark-light theme verified
  },
  blackButtonText: {
    color: theme.COLOR_TEXT_INVERSE_PRIMARY,
  },
  invertedButton: {
    backgroundColor: theme.COLOR_BG_INVERSE,
  },
  invertedButtonText: {
    color: theme.COLOR_TEXT_INVERSE_PRIMARY,
  },
  dangerButton: {
    backgroundColor: theme.COLOR_BG_CRITICAL_PRIMARY,
  },
  dangerButtonText: {
    color: theme.COLOR_TEXT_FIXED,
  },
  buttonSmall: {
    gap: rw(4),
    height: rh(32),
    paddingHorizontal: rw(12),
    borderRadius: rw(theme.SIZE_BUTTON_BORDER_RADIUS),
  },
  buttonMedium: {
    gap: rw(4),
    height: rh(40),
    paddingHorizontal: rw(16),
    borderRadius: rw(theme.SIZE_BUTTON_BORDER_RADIUS),
  },
  buttonSmallText: {},
  buttonMediumText: {},
  disabled: {
    backgroundColor: theme.COLOR_BG_DISABLED,
  },
  disabledText: {
    color: theme.COLOR_TEXT_DISABLED,
  },
}))
